export default __webpack_public_path__ + "static/media/aerial_platform_bw_cropped.e9ff4290.webp";